import computeMilesToMeters from '../../utils/computeMilesToMeters'
import { isString } from '../../utils/checks'
import { LOCATION_TYPE } from '../location/constants'
import {
  SearchRadiusInMiles,
  AROUND_RADIUS_GLOBAL
} from '../../constants/searchRadius'

type SearchRadiusReturnType = number | 'all'

export const getCenterSearchRadiusByLocationTypeInMiles = (
  locationType: string
): SearchRadiusReturnType => {
  switch (locationType) {
    case LOCATION_TYPE.CITY:
      return SearchRadiusInMiles.CITY
    case LOCATION_TYPE.REGION:
      return SearchRadiusInMiles.REGION
    case LOCATION_TYPE.COUNTRY:
      return SearchRadiusInMiles.COUNTRY
    case LOCATION_TYPE.COLLOQUIAL_AREA:
      return SearchRadiusInMiles.COLLOQUIAL_AREA
    default:
      return AROUND_RADIUS_GLOBAL
  }
}

export const getCenterSearchRadiusByLocationTypeInMeters = (
  locationType: string
): SearchRadiusReturnType => {
  const radius = getCenterSearchRadiusByLocationTypeInMiles(locationType)

  if (isString(radius)) {
    return radius
  }

  // We use 'as number' because the return type is SearchRadiusReturnType, which can be a number or a string
  // In case of string, we return 'all', which is handled by the if condition above
  return computeMilesToMeters(
    getCenterSearchRadiusByLocationTypeInMiles(locationType) as number
  )
}
